module.exports = __webpack_public_path__ + "static/media/arrow-long-curved3.7f7b31d9.svg";